import * as Yup from 'yup';

export const practiceConnectValidationSchema = Yup.object().shape({
  reason: Yup.string()
    .required('Reason is required')
    .min(3, 'Reason must be at least 3 characters'),
  monitoringOption: Yup.string()
    .required('Monitoring option is required')
    .oneOf(['Always', 'Sometimes', 'Never'], 'Invalid monitoring option'),
  selectedTools: Yup.array()
    .min(1, 'At least one tool must be selected'),
});
